import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';

const withNameSpace = withGenesysCloudStoreNameSpace('Cobrowse');

export const toggleCobrowseVisibility = createAction(
  withNameSpace('Toggle Cobrowse Panel Visibility'),
  props<{ conversationId: string; visibility: boolean }>()
);

export const setAllowedCobrowse = createAction(
  withNameSpace('Set Allowed Cobrowse Panel'),
  props<{ conversationId: string; allowed: boolean }>()
);
